import styled from '@emotion/styled'

export const ButtonStyled = styled.button`
  display: inline-block;
  border-radius: 6px;
  font-family: 'Open Sans', sans-serif;
  font-weight: bold;
  border: none;
  cursor: pointer;
  text-align: center;
  line-height: 1.5;
  width: 80px;
  height: 46px;
  margin-right: 4px;

  &:focus {
    outline: 0 !important;
  }

  background: #ffdd00;
  color: #2b3034;
  transition: all 0.3s;

  &:hover {
    background: '#FFE74C';
  }
`
